export default __webpack_public_path__ + "static/media/72659ea37e5eb1277248e4edc7a44ee4.png";